export const defaultMuiProps = {
  margin: 'normal',
  variant: 'outlined'
};
